import linksCollection from '../../../shared/src/rest/linksRest';

/**
 * ====================================
 * The actions
 * ====================================
 */
const SUCCESS_GET_LINKS = 'SUCCESS_GET_LINKS';
const FAILURE_GET_LINKS = 'FAILURE_GET_LINKS';

/**
 * ====================================
 * The actions creators
 * ====================================
 */
export const successGetLinks = links => ({
  type: SUCCESS_GET_LINKS,
  payload: links,
});

export const failureGetLinks = () => ({
  type: FAILURE_GET_LINKS,
});

export const loadLinks = () => dispatch => (
  linksCollection.getAll()
    .then((response) => {
      dispatch(successGetLinks(response.body(false)));
    })
    .catch((err) => {
      console.error('Error while loading links', err);
      dispatch(failureGetLinks());
    })
);

/**
 * ====================================
 * The reducer
 * ====================================
 */
const initialState = {
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_GET_LINKS: {
      return {
        data: action.payload,
      };
    }
    case FAILURE_GET_LINKS: {
      // We keep the links we already have
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/links/linksDucks.js